import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { DashboardSimpleCountDto } from './../../../../service/dto';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-simple-count',
  standalone: false,
  templateUrl: './dashboard-simple-count.component.html',
  styleUrl: './dashboard-simple-count.component.scss'
})
export class DashboardSimpleCountComponent {
	@Input() input!: DashboardSimpleCountDto;
	faArrowUp = faArrowUp;
	faArrowDown = faArrowDown;
}
